var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.svgClass,attrs:{"disabled":"","aria-hidden":"true"},on:{"click":_vm.doClick}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }